import * as model from "@/model/em/opcClient/EmOpcWatchEowModel";

/**
 * edit页面装载
 * @param _this
 * @param entity
 * @param pathType
 */
function editMounted(_this) {
    //如果是新增，就新建vuex的entity，并设置vuex的crudState为new
    if (_this.pathType === "new") {
        _this.$store.commit(_this.modelName + "/setNewEntity", {});
        _this.$store.commit(_this.modelName + "/setCrudState", 'new');
    }
}

/**
 * edit页面保存数据
 * @param _this
 * @param modelName
 */
function editHandleSave(_this) {
    _this.$validator.validateAll().then(isValid => {
        if (isValid) {
            _this.$store.dispatch('base/MMFSave', _this.modelName);
        }
    });
}

/**
 * edit页面取消操作
 * @param _this
 * @param modelName
 */
function editHandleCancel(_this) {
    _this.$store.dispatch('base/MMFbackToList', _this.modelName);
}

/**
 * edit页面获取pathType
 * @param _this
 * @returns {any}
 */
function getEditPathType(_this, modelName) {
    return _this.$route.query.pathType ? _this.$route.query.pathType : modelName && _this.$store.state[modelName].crudState ? _this.$store.state[modelName].crudState : "new"
}

/**
 * list页面获取pathType
 * @param _this
 * @returns {any}
 */
function getListPathType(_this) {
    // base.js中的save方法会自动跳转到list，那个就不带pathType参数。通过这样的设置，可以让新增记录成功后，直接跳转到待办页面,而不是查询页
    return _this.$route.query.pathType ? _this.$route.query.pathType : 'edit'
}

/**
 * 跳转到带holder的list
 * @param _this
 * @param childModelName
 * @param filterHolder
 * @param entityHolder
 */
function gotoHolderList(_this, childModelName, filterHolder, entityHolder,queryParam={}) {
    //设置filterHolder
    _this.$store.commit(childModelName + "/setFilterHolder", filterHolder)
    //设置entityHolder
    _this.$store.commit(childModelName + "/setEntityHolder", entityHolder)
    //清空查询条件
    _this.$store.dispatch("emBase/emBaseClearFilter", {entity:childModelName}).then(() => {
        //跳转:判断路由参数inline=1，如果是，跳转时也需要传递该参数
        if (_this.$route.query.inline && _this.$route.query.inline === "1") {
            queryParam = Object.assign({pathType: "fromParent",inline:"1"},queryParam)
            // _this.$router.push({name: childModelName + "List", query: {pathType: "fromParent",inline:"1"}});
        } else {
            // _this.$router.push({name: childModelName + "List", query: {pathType: "fromParent"}});
            queryParam = Object.assign({inline:"1"},queryParam)
        }
        _this.$router.push({name: childModelName + "List", query: queryParam});
    }).then(() => {
        _this.$store.dispatch("emBase/emBaseQueryByFilter", {entity:childModelName})
    })
}

/**
 * 弹出entityModalSelect
 * @param _this
 * @param col
 */
function handelShowEntityModalSelect(_this, col, setWhat, row) {
    _this.$_emCommonViewsUtil_modalSelectEntity = col.form.entity
    _this.$_emCommonViewsUtil_modalSelectCol = col
    _this.$_emCommonViewsUtil_modalSelectSetWhat = setWhat
    _this.$_emCommonViewsUtil_modalFromRow = row
    _this.$refs['emModalEntitySelect'].showModal();
}

/**
 * entityModalSelect选中某条记录
 * @param _this
 * @param selectedItem
 * @param setWhat
 */
function handleEntitySelected(_this, selectedItem) {
    let setWhat = _this.$_emCommonViewsUtil_modalSelectSetWhat
    let modalSelectCol = _this.$_emCommonViewsUtil_modalSelectCol
    let modalFromRow = _this.$_emCommonViewsUtil_modalFromRow
    //根据type决定是设置vuex的filter还是entity，list设置filter，edit设置entity
    let mutationName = () => {
        if (setWhat === 'filter') {
            return _this.modelName + '/setFilterAttribute'
        } else if (setWhat === 'entity') {
            return _this.modelName + '/setEntityAttribute'
        } else if (setWhat === 'editRow') {
            return _this.modelName + '/setRow'
        }
    }
    let suffix = setWhat === "setFilter" ? "Filter" : "";
    //判断是否绑定了其他字段，如果是，就弄出来弄成数组
    let fieldsBindingObj = modalSelectCol.form.fieldsBindingByEntityModalSelected ?
        JSON.parse(modalSelectCol.form.fieldsBindingByEntityModalSelected) : null
    //selectedItem为空，就清空相应的attribute
    if (selectedItem === null) {
        //清空他自己
        _this.$store.commit(mutationName, {
            key: modalSelectCol.key,
            newValue: null,
            row: modalFromRow
        })
        //清空其他绑定字段
        if (fieldsBindingObj) {
            Object.getOwnPropertyNames(fieldsBindingObj).forEach((key) => {
                _this.$store.commit(mutationName, {
                    key: key + suffix,
                    newValue: null,
                    row: modalFromRow
                })
            })
        }
    } else {
        //给自己赋值：如果model的fieldConfig中有form.correspondingField并且在selectedItem中也有同名属性，就赋值
        if (modalSelectCol.form.correspondingField && selectedItem[modalSelectCol.form.correspondingField]) {
            _this.$store.commit(mutationName, {
                key: modalSelectCol.key,
                newValue: selectedItem[modalSelectCol.form.correspondingField],
                row: modalFromRow
            })
        }
        //给其他绑定字段赋值
        if (fieldsBindingObj) {
            Object.getOwnPropertyNames(fieldsBindingObj).forEach((key) => {
                _this.$store.commit(mutationName, {
                    key: key + suffix,
                    newValue: selectedItem[fieldsBindingObj[key]],
                    row: modalFromRow
                })
            })
        }
    }
}

/**
 * 返回对象level级的grandParent
 * @param entity
 * @returns 没有就返回null
 */
function getGrandParentIdByEntity(entity) {
    if (entity.level) {
        let levelArray = entity.level.split(".")
        if (levelArray.length > 3) {
            return levelArray[levelArray.length - 3]
        }
    }
    return null
}

/**
 * 返回对象level的父level
 * @param entity
 * @returns {string|null}
 */
function getParentLevelByEntity(entity) {
    if (entity && entity.level && entity.level.indexOf(".") > 0) {
        var temp = entity.level.slice(0, -1)
        if (temp.indexOf(".") > 0) {
            return temp.slice(0, temp.lastIndexOf(".") + 1)
        }
    }
    return null
}

/**
 * 返回level的父level
 * @param entity
 * @returns {string|null}
 */
function getParentLevelByLevel(level) {
    if (level && level.indexOf(".") > 0) {
        var temp = level.slice(0, -1)
        if (temp.indexOf(".") > 0) {
            return temp.slice(0, temp.lastIndexOf(".") + 1)
        }
    }
    return null
}

/**
 * 成功提示
 */
function showSuccess(_this, msg) {
    _this.$store.dispatch("base/showSuccess", {
        userAlertSuccessStr: msg,
        dismissCountDown: 5,
        userAlertSuccessVisible: false,
    })
}

/**
 * 警告提示
 */
function showWarning(_this, msg) {
    _this.$store.dispatch("base/showWarning", {
        userAlertWarningStr: msg,
        userAlertWarningVisible: true,
    })
}

/**
 * 错误提示
 */
function showDanger(_this, msg) {
    _this.$store.dispatch("base/showDanger", {
        userAlertDangerStr: msg,
        userAlertDangerVisible: true,
    })

}

export default {
    editMounted,
    editHandleSave,
    editHandleCancel,
    getEditPathType,
    getListPathType,
    gotoHolderList,
    handelShowEntityModalSelect,
    handleEntitySelected,
    getGrandParentIdByEntity,
    getParentLevelByEntity,
    getParentLevelByLevel,
    showSuccess,
    showWarning,
    showDanger
};